module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mapPower"
  }, [_c('div', {
    staticClass: "xiexinChangePowerMap",
    staticStyle: {
      "top": "0"
    },
    attrs: {
      "id": "container"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mapPower-btn"
  }, [_c('van-button', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "type": "info",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.handleToAddress(1)
      }
    }
  }, [_vm._v("前往装货点")]), _vm._v(" "), _c('van-button', {
    attrs: {
      "type": "info",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.handleToAddress(2)
      }
    }
  }, [_vm._v("前往卸货点")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ff801e9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/xiexinmapwebview/mapwebviewPowertransport.vue
// module id = 493
// module chunks = 1